import { GiftIcon } from '@heroicons/react/24/outline';

// The in-app rewards dashboard, not the campaign's marketing page. Both callers only ever show
// this footnote to a teacher holding a payable bts_2026_september_scramble tier, and /referral
// features that same program — so a teacher who can see this note can always reach the page.
// (canAccessReferralPage asks whether the key is configured; holding a tier from it proves that.)
const REWARDS_URL = '/referral';

/**
 * ReferralBonusFootnote — the sharer-side bonus promise, under an invite ask.
 *
 * Shared by ShareReferralModal and the onboarding wizard's invite step, so restyling it
 * changes both. Each caller owns the decision to show it: the promise is a payout, so it belongs
 * only to a teacher who holds a program that can pay one.
 *
 * Deliberately states no amounts. The terms are the program's, an operator can change them, and
 * GET /referral/me can't describe a repeating tier — `next_tier` carries no is_repeating,
 * repeat_interval or max_occurrences — so that helper would render "$5 per invite up to $100"
 * as a one-shot "$5 for 1 teacher".
 */
const DEFAULT_TEXT =
  'Earn credit to the Diffit swag store when those you invite generate their first resource.';

// `text` is the program's `copy.bonus_footnote`; absent means the default sentence.
const ReferralBonusFootnote = ({ text = DEFAULT_TEXT }) => (
  <div className='mt-6 flex items-start gap-2'>
    <GiftIcon className='mt-0.5 h-4 w-4 shrink-0 text-gray-400' />
    <p className='text-xs text-gray-600'>
      {/* Plain <a>: react-router's <Link> resolves relative to this app. */}
      <span>
        {text}{' '}
        <a
          href={REWARDS_URL}
          target='_blank'
          rel='noopener noreferrer'
          className='font-medium text-emerald-600 underline hover:text-emerald-700'>
          Track your credit
        </a>
      </span>
    </p>
  </div>
);

export default ReferralBonusFootnote;
